import { useState, useEffect } from "react"

import { useParams } from "react-router-dom"

import { useScenario } from "../contexts/ScenarioContext"

import PhaseLayout        from "../components/layouts/PhaseLayout"

import PhaseCheckList     from "../components/PhaseCheckList"
import PatientStatus      from "../components/PatientStatus"
import Panel              from "../components/Panel"

const Section = () => {
    const { phaseID, subPhaseID } = useParams()
    const { scenario, currPhase, setCurrPhase, setCurrSubPhase, setCurrIntv, setCurrIntvCat, setShowIntvSelection } = useScenario()
    const [ section, setSection] = useState(null)


    useEffect(
        () => {
            // set the phase/subphase to their ids (subPhaseID may be undefined)
            setCurrPhase(phaseID)
            setCurrSubPhase(subPhaseID ? subPhaseID : null)
            /* upon navigating to a new phase/subphase:
            - clear the current intervention and category.
            - hide intervention categories
            */
            setCurrIntv(null)
            setCurrIntvCat("")
            setShowIntvSelection(true)

            // find the data associated with the current phase/subPhase add assign it
            // to local state var section
            const phaseData = scenario.phaseData.find(rec => rec.id === phaseID)
            if (!!phaseData.subPhases && !!subPhaseID) {
                const subPhaseData = phaseData.subPhases.find(rec => rec.id === subPhaseID)
                setSection(subPhaseData)
            } else {
                setSection(phaseData)
            }
        }, 
        [phaseID, subPhaseID]
    )


    if (!currPhase) {
        return (<div>phase not set yet</div>)
    } 
    return (
        <PhaseLayout
            top={<PhaseCheckList section={section} />}
            bottom={
            <Panel title="Patient Status" collapsable scrollBody>
                <PatientStatus />
                </Panel>
            }
        />
    )
        
}

export default Section